import { AfterViewInit, Directive, ElementRef, inject, InputSignal, input, ChangeDetectorRef } from '@angular/core';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import Swiper from 'swiper';


@Directive({
  selector: '[appSwiper]',
  standalone: true,
})
export class SwiperDirective implements AfterViewInit {
  swiperOptions: InputSignal<any> = input.required<any>();
  private readonly el: ElementRef = inject(ElementRef);
  private readonly cdr: ChangeDetectorRef = inject(ChangeDetectorRef);
  private swiperInstance!: Swiper; // 🟢 هنخزن نسخة من Swiper هنا



  ngAfterViewInit() {
    Swiper.use([Navigation, Pagination, Autoplay]);

    this.cdr.detectChanges();
    setTimeout(() => {
      const rawOptions = this.swiperOptions();
      this.swiperInstance = new Swiper(this.el.nativeElement, rawOptions);
    });
  }

  public updateSwiper() {
    if (this.swiperInstance) {
      this.swiperInstance.update();
    }
  }
}
